import { useHttp } from '../http'

export const useGlossaryDefinitionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`glossary-definitions/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`glossary-definitions`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`glossary-definitions/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`glossary-definitions`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`glossary-definitions/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}